import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import QRCode from 'qrcode';
import '../styles/GetApp.css';

const GetAppPage = () => {
  const navigate = useNavigate();
  const [showAppModal, setShowAppModal] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Generate QR code when modal opens
  useEffect(() => {
    if (showAppModal && !qrCodeUrl) {
      const generateQRCode = async () => {
        try {
          const url = 'https://yesod.us/app';
          const qrDataUrl = await QRCode.toDataURL(url, {
            width: 200,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          });
          setQrCodeUrl(qrDataUrl);
        } catch (err) {
          console.error('Error generating QR code:', err);
        }
      };
      generateQRCode();
    }
  }, [showAppModal, qrCodeUrl]);

  // Device detection function
  const detectDeviceAndRedirect = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    let appStoreUrl;
    
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      appStoreUrl = 'https://apps.apple.com/us/app/yesod/id6748472269';
    } else if (/android/i.test(userAgent)) {
      appStoreUrl = 'https://play.google.com/store/apps/details?id=us.yesod.app';
    } else {
      appStoreUrl = 'https://apps.apple.com/us/app/yesod/id6748472269';
    }
    
    window.open(appStoreUrl, '_blank');
  };

  const handleDownloadClick = () => {
    if (isMobile) {
      detectDeviceAndRedirect();
    } else {
      setShowAppModal(true);
    }
  };

  const handleSignOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <div className="get-app-container">
      <div className="get-app-content">
        <div className="get-app-logo">
          <img 
            src="https://xvhellooihpelwifxuik.supabase.co/storage/v1/object/public/assets/Yesod%20Logo%204K%20(1).png" 
            alt="Yesod Logo"
          />
        </div>

        <h1 className="get-app-title">Welcome Back</h1>
        
        <p className="get-app-subtitle">
          To manage your prayer chains and create new ones, please use the Yesod mobile app
        </p>

        <button 
          className="get-app-cta"
          onClick={handleDownloadClick}
        >
          <ChevronDown size={16} className="button-arrow" />
          <span>Download for iOS & Android</span>
        </button>

        <button 
          className="sign-out-link"
          onClick={handleSignOut}
        >
          Sign Out
        </button>
      </div>

      {/* App Download Modal (Desktop Only) */}
      {showAppModal && (
        <div className="app-modal-overlay" onClick={() => setShowAppModal(false)}>
          <div className="app-modal" onClick={(e) => e.stopPropagation()}>
            <button className="app-modal-close" onClick={() => setShowAppModal(false)}>×</button>
            
            <div className="app-modal-content">
              <h2 className="app-modal-title">Scan to get it on mobile</h2>
              
              <div className="app-modal-qr">
                {qrCodeUrl ? (
                  <img src={qrCodeUrl} alt="QR Code to download Yesod app" className="qr-code-image" />
                ) : (
                  <div className="qr-loading">Generating QR code...</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GetAppPage;
